import React from 'react';

import { Footer, GlobalError, Header } from '@bessemercws/components';
import { useErrorLogger } from '@bessemercws/graphql';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

import { WithHeaderContainer } from '#/layouts/WithHeader/WithHeader.styles';

export const ErrorBoundary = ({ children }: { children: JSX.Element }) => {
  const logError = useErrorLogger();

  const navigateHome = () => {
    window.location.href = '/';
  };

  const FallbackPage = () => (
    <WithHeaderContainer data-testid="with-header">
      <Header className="header" onLogoClick={navigateHome} />
      <GlobalError onRefresh={navigateHome} />
      <Footer className="footer" data-testid="footer-container"></Footer>
    </WithHeaderContainer>
  );

  return (
    <ReactErrorBoundary fallback={<FallbackPage />} onError={logError}>
      {children}
    </ReactErrorBoundary>
  );
};
